export enum AppObject {
    user = 'user',
    application = 'application',
    client = 'client',
    restriction = 'restriction',
    tariff = 'tariff',
    licence = 'licence',
    action = 'action'
}
